import {
  all, call, fork, put, takeEvery,
} from 'redux-saga/effects';

// action creators
import { doneIndicator, error } from '../../actions/httpActions';
import { startSubmit, setSubmitFailed, setSubmitSucceeded } from 'redux-form/immutable';

// api
import { patch } from '../../sources/api/client';
import membershipConcernService from '../../sources/api/membershipConcernService';

// constants
import { MEMBERSHIP_CONCERN_UPDATE, MEMBERSHIP_CONCERN_UPDATE_INIT } from '../../constants/membershipConcernTypes';

// lib
import httpSaga from '../../lib/httpSaga';

// schemas
import { membershipConcernSchema } from '../../schemas/membershipConcern';

export function* membershipConcernUpdate(action) {
  if (action['@@redux-saga/SAGA_ACTION']) return;

  const { membershipConcernId, ...values } = action.payload;
  const FORM = action.payload.formName || ' ';
  yield put(startSubmit(FORM));

  try {
    yield* httpSaga(MEMBERSHIP_CONCERN_UPDATE,
      call(patch, membershipConcernService, membershipConcernId, { ...values }),
      {
        schema: membershipConcernSchema,
      });

    yield put(setSubmitSucceeded(FORM));
  } catch (err) {
    yield put(setSubmitFailed(FORM));
    yield put(error(MEMBERSHIP_CONCERN_UPDATE, err));
  } finally {
    yield put(doneIndicator(MEMBERSHIP_CONCERN_UPDATE));
  }
}

export function* watchmembershipConcernUpdate() {
  yield takeEvery(MEMBERSHIP_CONCERN_UPDATE_INIT, membershipConcernUpdate);
}

export default function* root() {
  yield all([
    fork(watchmembershipConcernUpdate),
  ]);
}
